import CMSBg from "../images/cmsBg.jpg";
import CMSBgMobile from "../images/cmsBgMobile.jpg";import Wrapper from "../components/wrapper/Wrapper";
import { useEffect, useState } from "react";
import { getBlogDetails } from "../servies/services";
import { useLocation, useParams } from "react-router-dom";

const BlogDetails = () => {
    const [data, setData] = useState({})
    const { title } = useParams()
    const location = useLocation();


    useEffect(() => {
        if (title) {
            const getData = async () => {
                const resp = await getBlogDetails(title)
                setData(resp?.data?.data)
            }
            getData()
        }
    }, [title])

    return (
        <Wrapper
            showTopFooter={false}
            desktopImage={CMSBg}
            mobileImage={CMSBgMobile}
            firstTitle="Journey Beyond Limits"
            bannerHeading={location?.pathname?.includes("cms") ? data?.title : "Blog Details"}
        >
            <div className="cms-content">
                <h4>{data?.title}</h4>
                <div className="contents" dangerouslySetInnerHTML={{ __html: data?.description }}></div>
            </div>
        </Wrapper>
    )
};


export default BlogDetails;

